import React, { FC } from 'react';

import styled from '@emotion/styled';

export interface NavbarDropdownGroupProps {
  /** Allows the component to get additional styles. */
  className?: string;
}

const StyledNavbarDropdownGroup = styled.div<NavbarDropdownGroupProps>(
  ({ theme }) => ({
    label: 'navbarDropdownGroup',
    flex: 1,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    maxWidth: '50%',
    [`@media (max-width: ${theme.navbar.collapseAt})`]: {
      maxWidth: '100%',
      flex: '0 1 100%'
    }
  })
);

const NavbarDropdownGroup: FC<NavbarDropdownGroupProps> = ({ className, ...rest }) => (
  <StyledNavbarDropdownGroup {...rest} className={className} />
);

export { NavbarDropdownGroup };
export default NavbarDropdownGroup;
